// import {filterTime} from '@/common/js/nativeInteraction';
import moment from 'moment';
const common = {
// 格式化时间
  filterTime (val, arg = 'YYYY-MM-DD HH:mm:ss') {
    if (!val) return '';
    val = new Date(val).getTime();
    // eslint-disable-next-line no-undef
    return moment(val).format(arg);
  },
  getDateTimeStamp (dateStr) {
    return Date.parse(dateStr.replace(/-/gi, '/'));
  },
  // 转换时间  （xx:xx， 几天前， 几分钟前）
  /*
  * 时间戳/日期时间格式字符串 => xx:xx， 几天前， 几分钟前
  */
  getDateDiff (dateStr) {
    var publishTime = this.getDateTimeStamp(dateStr) / 1000;
    var dSeconds;
    var dMinutes;
    var dHours;
    var dDays;
    var timeNow = parseInt(new Date().getTime() / 1000);
    var d;

    var date = new Date(publishTime * 1000);
    var Y = date.getFullYear();
    var M = date.getMonth() + 1;
    var D = date.getDate();
    var H = date.getHours();
    var m = date.getMinutes();
    var s = date.getSeconds();
    // 小于10的在前面补0
    if (M < 10) {
      M = '0' + M;
    }
    if (D < 10) {
      D = '0' + D;
    }
    if (H < 10) {
      H = '0' + H;
    }
    if (m < 10) {
      m = '0' + m;
    }
    if (s < 10) {
      s = '0' + s;
    }

    d = timeNow - publishTime;
    dDays = parseInt(d / 86400);
    dHours = parseInt(d / 3600);
    dMinutes = parseInt(d / 60);
    dSeconds = parseInt(d);

    if (dDays > 0 && dDays < 3) {
      return dDays + '天前';
    } else if (dDays <= 0 && dHours > 0) {
      return dHours + '小时前';
    } else if (dHours <= 0 && dMinutes > 0) {
      return dMinutes + '分钟前';
    } else if (dSeconds < 60) {
      if (dSeconds <= 0) {
        return '刚刚';
      } else {
        return dSeconds + '秒前';
      }
    } else if (dDays >= 3 && dDays < 30) {
      return Y + '-' + M + '-' + D + ' ' + H + ':' + m;
    } else if (dDays >= 30) {
      return Y + '-' + M + '-' + D + ' ' + H + ':' + m;
    }
  },
  picToBase64 (file, cb) {
    const reader = new FileReader();
    // 将文件以Data URL形式读入页面
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      // var ImgFileSize = reader.result.substring(reader.result.indexOf(",") + 1).length;//截取base64码部分（可选可不选，需要与后台沟通）
      cb(reader.result);
    };
  },

  // 数字小写转大写
  DX (num) {
    let changeNum = ['零', '一', '二', '三', '四', '五', '六', '日', '八', '九']; // changeNum[0] = "零"
    let unit = ['', '十', '百', '千', '万'];
    num = parseInt(num);
    let getWan = (temp) => {
      let strArr = temp.toString().split('').reverse();
      let newNum = '';
      for (var i = 0; i < strArr.length; i++) {
        newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum;
      }
      return newNum;
    };
    let overWan = Math.floor(num / 10000);
    let noWan = num % 10000;
    if (noWan.toString().length < 4) noWan = '0' + noWan;
    return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num);
  },
  // 去除开头结尾的两个逗号
  removeComma (str) {
    return str.replace(/(^,)|(,$)/g, '');
  },
  // 获取当前年月日
  getNowFormatDate () {
    var date = new Date();
    var seperator1 = '-';
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = '0' + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },

  // 获取当前的年月日往后或者往前推迟时间
  addDate (date, times) {
    var addDate = new Date(date);
    var addArr = times.split('*');
    var addTime = parseInt(addArr[0]);
    var addType = addArr[1];
    switch (addType) {
      case 'Y':
        addDate.setFullYear(addDate.getFullYear() + addTime);
        return addDate;
      case 'M':
        addDate.setMonth(addDate.getMonth() + addTime);
        return addDate;
      case 'D':
        addDate.setDate(addDate.getDate() + addTime);
        return addDate;
      case 'H':
        addDate.setHours(addDate.getHours() + addTime);
        return addDate;
      case 'm':
        addDate.setMinutes(addDate.getMinutes() + addTime);
        return addDate;
      case 's':
        addDate.setSeconds(addDate.getSeconds() + addTime);
        return addDate;
      default:
        addDate.setTime(addDate.getTime() + addTime);
        return addDate;
      // addDate(当前年月日, '6*Y'))  //加6年
      // addDate(当前年月日, '-6*Y'))  //减6年
    }
  },

  weekDefault () {
    let weekList = [
      {id: '1', label: '周一'},
      {id: '2', label: '周二'},
      {id: '3', label: '周三'},
      {id: '4', label: '周四'},
      {id: '5', label: '周五'},
      {id: '6', label: '周六'},
      {id: '7', label: '周日'}
    ];
    return weekList;
  },

  // 选择的图标
  getIcon () {
    let iconList = [
      'iconfont icon-shouye', 'iconfont icon-shujuku', 'iconfont icon-shuju', 'iconfont icon-shezhi', 'icon-laoshi', 'icon-xuesheng1', 'icon-tongji3', 'icon-yewu', 'icon-tongji2', 'icon-chengji1', 'icon-daxue', 'icon-fenxi1', 'icon-tongji1', 'icon-fenxi', 'icon-transaction_fill',
      'icon-praise_fill', 'icon-order_fill', 'icon-group_fill', 'icon-document_fill', 'icon-createtask_fill', 'icon-addressbook_fill', 'icon-addpeople_fill', 'icon-bianqian', 'icon-qizhi1',
      'icon-huabanfuben', 'icon-banshidating', 'icon-mark', 'icon-shixiang', 'icon-qizhi', 'icon-gongju1', 'icon-sheji',
      'icon--zhuanhuan', 'icon-tuichu1', 'icon-shuaxin', 'icon-quanping', 'icon-tuichu',
      'icon-shijianlishijilujishizhongbiaomianxing', 'icon-gongju', 'icon-yueliang', 'icon-crm12', 'icon-xuesheng', 'icon-jiangbei1', 'icon-chengji', 'icon-dangyuan', 'icon-dizhi',
      'icon-xuesheng--', 'icon-xuefen'
    ];
    return iconList;
  },
  tzUeconfig () {
    let TZ = ['fullscreen', 'source', '|', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|',
      'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|', 'rowspacingtop', 'rowspacingbottom', 'lineheight', '|', 'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|', 'indent', '|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|', 'simpleupload'
    ];
    return TZ;
  }
};

export default common;



// WEBPACK FOOTER //
// ./src/common/js/common.js